import Vue from 'vue'
import VuePlyr from 'vue-plyr'

Vue.use(VuePlyr)


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/plyr.js